import api from 'api/api'
import { getCachedAnswer, isViewerHydratedAnswerCacheEntry } from 'state/cache'
import { createAnswerHydrationQueue } from 'state/answerHydrationQueueCore'

const answerHydrationQueue = createAnswerHydrationQueue({
    getAnswers: answerIds => api.getAnswers(answerIds),
    getCachedAnswer,
    isHydratedAnswerCacheEntry: isViewerHydratedAnswerCacheEntry,
})

export const queueAnswerHydration = answerHydrationQueue.queueAnswerHydration
